import $ from 'jquery';
import {RECENTLY_VIEWED_EVENT_LIMIT, RECENTLY_VIEWED_ARRANGEMENT_LIMIT, VIEWED_ITEM_TYPES} from '#api/services/user/userConsts';
import userCookiesService from '../services/userCookiesService';

class RecentlyViewedItems {
	constructor() {
		this.init();
	}

	init() {
		this._initEvents();
	}

	/**
	 * @param {string | number} id
	 */
	saveViewedEvent(id) {
		this._saveViewedItem(id, VIEWED_ITEM_TYPES.EVENT);
	}
	
	/**
	 * @param {string | number} id
	 */
	saveViewedArrangement(id) {
		this._saveViewedItem(id, VIEWED_ITEM_TYPES.ARRANGEMENT);
	}

	/**
	 * @param {string | number} itemId
	 * @param {string} 	        itemType
	 */
	_saveViewedItem(itemId, itemType) {
		let viewedItems = this._getViewedItems(itemType);
		
		const viewedItemsLimit = itemType === VIEWED_ITEM_TYPES.EVENT ? RECENTLY_VIEWED_EVENT_LIMIT : RECENTLY_VIEWED_ARRANGEMENT_LIMIT,
		      storedIds        = viewedItems.map((item) => item.id);

		// if it was already saved, remove it first
		if (storedIds.includes(itemId)) {
			itemType === VIEWED_ITEM_TYPES.EVENT
							? userCookiesService.removeViewedEvent(itemId)
							: userCookiesService.removeViewedArrangement(itemId);

			viewedItems = this._getViewedItems(itemType);
		}

		viewedItems.unshift({
			'id'  : itemId,
			'time': Date.now()
		});
		viewedItems.length = Math.min(viewedItems.length, viewedItemsLimit);

		itemType === VIEWED_ITEM_TYPES.EVENT
					? userCookiesService.storeRecentlyViewedEvents(viewedItems)
					: userCookiesService.storeRecentlyViewedArrangements(viewedItems);
	}

	/**
	 * @param {string} itemType
	 * @returns {!Array}
	 * @private
	 */
	_getViewedItems(itemType) {
		return itemType === VIEWED_ITEM_TYPES.EVENT
				? userCookiesService.getRecentlyViewedEvents()
				: userCookiesService.getRecentlyViewedArrangements();
	}
	
	/** @private */
	_initEvents() {
		$('.recently-viewed-block').on('click', '.item i', (ev) => {
			const $clickedItem 		= $(ev.currentTarget).parent(),
				  $clickedItemData 	= $clickedItem.data(),
				  itemId 			= parseInt($clickedItemData.id),
				  itemType 			= $clickedItemData.type;

			$clickedItem.remove();

			itemType === VIEWED_ITEM_TYPES.EVENT
							? userCookiesService.removeViewedEvent(itemId)
							: userCookiesService.removeViewedArrangement(itemId);

			if (!userCookiesService.hasRecentlyViewedItem()) {
				if ($('.ticketInformationBanner').length >= 1) {
					$('.recently-viewed-block').hide();
				} else {
					$('.recently-viewed-block').addClass('invisible'); // is original
				}
			}
		});
	}
}

export default RecentlyViewedItems;